<template>
    <a-card title="菜单树(鼠标右键点击菜单项)" class="menu-tree">
        <template #extra>
            <a-button-group>
                <a-button type="primary" size="small" @click="onAddMenu">新增</a-button>
            </a-button-group>
        </template>

        <template #default>


            <a-input-search placeholder="搜索" @change="onSearchChange"/>
            <a-tree
                :tree-data="treeData"
                v-model:selectedKeys="selectedKeys"
                :expanded-keys="expandedKeys"
                :auto-expand-parent="autoExpandParent"
                default-expand-all
                @select="onMenuSelect"
                @expand="onMenuExpand"
            >
                <template #title="{title,key}">
                    <a-dropdown :trigger="['contextmenu']">
                        <div>
                            <template v-if="title.indexOf(searchValue) > -1">
                                <span v-html="getSearchTitle(searchValue,title)"></span>
                            </template>
                            <span v-else>{{ title }}</span>
                        </div>
                        <template #overlay>
                            <a-menu>
                                <a-menu-item @click="onAddChildMenu(key)">新增</a-menu-item>
                                <a-menu-item @click="onEditMenu(key)">修改</a-menu-item>
                                <a-menu-item @click="onDeleteMenu(key)">删除</a-menu-item>
                            </a-menu>
                        </template>
                    </a-dropdown>
                </template>
            </a-tree>
        </template>
    </a-card>
    <menu-drawer ref="modal" form-primary-key-field="key" :menu-list="menuList" @finish="getTreeData"/>
</template>

<script>
import {convertTreeData, getParentKey} from "@/utils/convertData";
import MenuDrawer from "@/views/sys/menu/components/MenuDrawer";
import {sys_menu} from "@/api/adminService";
import bus from "@/utils/bus";

export default {

    name: "MenuTree",
    components: {MenuDrawer},
    data() {
        return {
            selectedKeys: [],
            menuList: [],
            treeData: [],
            expandedKeys: [],
            autoExpandParent: true,
            searchValue: '',
        }
    },
    created() {
        this.getTreeData();
    },
    methods: {
        onShowModal(refName, data = {}) {
            const refEle = this.$refs[refName];
            refEle.form = Object.assign({}, data);
            refEle.visible = true;
        },
        getTreeData() {
            this.getAction({
                url: sys_menu.getMenuListData
            }).then((res) => {
                this.menuList = res || [];
                this.treeData = convertTreeData({
                    datas: res || [],
                    rootValue: '1628606141145972737',
                    valueField: 'menuId',
                    titleField: 'menuName',
                    parentField: 'parentId'
                });
                this.expandedKeys = getParentKey({
                    val: '',
                    tree: this.menuList,
                    titleField: "menuName",
                    keyField: 'menuId'
                });
            })
        },
        onAddMenu() {
            this.onShowModal('modal', {
                type: 'menu',
                url: 'javascript:;',
                urlType: 1
            });
        },
        onAddChildMenu(key) {
            this.onShowModal('modal', {
                parentId: key,
                type: 'menu',
                url: 'javascript:;',
                urlType: 1
            });
        },
        onEditMenu(key) {
            this.getAction({
                url: sys_menu.getDetail,
                params: {id: key}
            }).then(res => {
                this.onShowModal('modal', res);
            })

        },
        onDeleteMenu(key) {
            let self = this;
            this.$confirm({
                title: '确认删除当前选中菜单及其全部子菜单?',
                content: "",
                okType: 'danger',
                onOk() {
                    self.postAction({
                        url: sys_menu.remove,
                        params: {
                            id: key
                        },
                        returnMsg: true
                    }).then(res => {
                        self.$message.success(res.msg || '删除成功')
                        self.selectedKeys = self.selectedKeys.filter(v => {
                            return v !== key
                        });
                        self.getTreeData();
                    })
                },
                onCancel() {
                }
            });
        },
        onSearchChange(e) {
            this.searchValue = e.target.value;
            this.expandedKeys = getParentKey({
                val: e.target.value,
                tree: this.menuList,
                titleField: 'menuName',
                keyField: 'menuId'
            });
            this.autoExpandParent = true;
        },
        onMenuSelect(selectedKeys) {
            bus.$emit('onMenuSelect', selectedKeys[0])
        },
        onMenuExpand(expandedKeys) {
            this.expandedKeys = expandedKeys;
            this.autoExpandParent = false;
        },
        getSearchTitle(searchValue, title) {
            return title.substr(0, title.indexOf(searchValue)) +
                '<span class="tc-red">' + searchValue + '</span>' +
                title.substr(title.indexOf(searchValue) + searchValue.length);
        }
    },
}
</script>

<style scoped lang="less">
.ant-card{
    background-color: #ffffff;
}
</style>
